import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { PaperMaterial } from "./paper-material";
const BrandReceipts = types.model({
  brand: types.maybeNull(types.string),
  totalStock: types.maybeNull(types.number),
});

const BrandGroup = types.model({
  brand: types.maybeNull(types.string),
  totalIssueStock: types.maybeNull(types.number),
  totalReceiptStock: types.maybeNull(types.number),
  totalStock: types.maybeNull(types.number),
  rollNumber: types.maybeNull(types.string),
});

export const PaperInventory = types.model({
  materialId: types.maybeNull(types.string),
  material: types.maybeNull(PaperMaterial),
  stock: types.maybeNull(types.number),
  totalIssueStock: types.maybeNull(types.number),
  totalReceiptStock: types.maybeNull(types.number),
  receiptGroupedItems: types.maybeNull(types.array(BrandReceipts)),
  groupedItems: types.maybeNull(types.array(BrandGroup)),
});

export interface IPaperInventory extends Instance<typeof PaperInventory> {}
export interface IPaperInventoryProperties
  extends SnapshotIn<typeof PaperInventory> {}
